
import clamp from '../../helpers/Clamp.js';
let openMenu = null;

export default {
  provide () {
    return {
      inMenu: true,
      inList: true,
      direction: 'block',
      close: this.close
    };
  },

  data () {
    return {
      show: false
    };
  },

  mounted () {
    window.addEventListener('click', (e) => {
      const path = e.composedPath();

      if (!this.$el || this.$el === e.target || path.includes(this.$el)) { return; }

      this.close();
    });

    this.addEvents();
  },

  methods: {
    close () {
      this.show = false;
    },
    addEvents () {
      window.addEventListener('blur', () => this.close());

      this.$el.parentElement.addEventListener('contextmenu', async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (openMenu) {
          openMenu();
        }

        openMenu = this.close;
        this.show = true;
        await this.$nextTick();
        const x = clamp(
          e.clientX,
          8,
          window.innerWidth - this.$el.clientWidth - 8
        );
        const y = clamp(
          e.clientY,
          8,
          window.innerHeight - this.$el.clientHeight - 8
        );
        if (this.$refs.menu) { this.$refs.menu.alignBubble(x, y); }
      });
    }
  }
};
